import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Avatar, Button, Tooltip } from "@mui/material";

import logo from "../../assets/Top Neighborhood Pros-03.png";
import { Link, NavLink, useNavigate } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import PostAddIcon from "@mui/icons-material/PostAdd";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import { green, red } from "@mui/material/colors";
import UpgradeOutlinedIcon from "@mui/icons-material/UpgradeOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import {
  useFindUserApiQuery,
  useLogoutUserMutation,
} from "../../services/apiSlice";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import Person3Icon from "@mui/icons-material/Person3";
import Menu from "@mui/material/Menu";

import MenuItem from "@mui/material/MenuItem";

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",

  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function UserDashBoardHeader() {
  const settings = ["Profile", "Account", "Dashboard", "Logout"];
  const navigate = useNavigate();
  const [logoutUser, { isLoading }] = useLogoutUserMutation();
  const {
    data,
    error: e,
    isError: is,
    isSuccess,
    isFetching,
  } = useFindUserApiQuery();
  const theme = useTheme();

  const [open, setOpen] = React.useState(false);
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  const handleLogout = async () => {
    const logout = await logoutUser();
    console.log({ logout });
    if (logout?.data?.success === true) {
      navigate("/");
      console.log("logout success");
    }
  };

  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar position="fixed" sx={{ background: "white", mb: 20 }} open={open}>
        <Toolbar>
          <IconButton
            // color="black"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={[
              {
                marginRight: 5,
                ...(open && { display: "none" }),
              },
            ]}
          >
            <MenuIcon />
          </IconButton>

          <Avatar
            alt="Top Neigbourhood pro"
            variant={"rounded"}
            className="lg:ml-10  text-black "
            sx={[
              { width: "10%", height: "10%" },
              (theme) => ({
                [theme.breakpoints.down("sm")]: {
                  px: 1,
                  width: "40%",
                  height: "40%",
                },
              }),
              (theme) => ({
                [theme.breakpoints.down("xs")]: {
                  // px: 1,
                  width: "40%",
                  height: "40%",
                },
              }),
              (theme) => ({
                [theme.breakpoints.down("md")]: {
                  px: 1,
                  width: "25%",
                  height: "25%",
                },
              }),
            ]}
            src={logo}
          />
          <Box sx={{ ml: "auto", display: "flex" }}>
            <Button
              component={NavLink}
              className="hover:bg-green-300"
              to={`/client-sign-in`}
              sx={{
                // my: 2,
                fontWeight: "bold",
                color: "black",
                display: "block",
                px: 3,
              }}
            >
              <NotificationsActiveOutlinedIcon color="secondary" />
            </Button>
            {/* <IconButton
              sx={[
                {},
                (theme) => ({
                  [theme.breakpoints.up("429")]: {
                    display: "none",
                  },
                }),
              ]}
            >
              <UpgradeOutlinedIcon />
            </IconButton> */}
          </Box>

          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                {/* <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" /> */}
                {/* <Typography textAlign="center">tope seun</Typography>{" "} */}
                <Button
                  sx={[
                    {
                      // my: 2,
                      fontWeight: "bold",
                      color: "white",
                      display: "flex",
                      px: 3,
                      background: green[600],
                    },
                    // (theme) => ({
                    //   [theme.breakpoints.down("429")]: {
                    //     display: "none",
                    //   },
                    // }),
                  ]}
                >
                  {isSuccess && data?.getUserObject?.firstname}
                </Button>{" "}
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              <MenuItem onClick={handleCloseUserMenu}>
                <Typography textAlign="center"></Typography>{" "}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="Logout">
                    <Button onClick={() => handleLogout()}>
                      <IconButton
                        sx={[
                          // { px: 3 },
                          (theme) => ({
                            [theme.breakpoints.up("321")]: {
                              // display: "none",
                            },
                          }),
                        ]}
                      >
                        <LogoutIcon />
                      </IconButton>{" "}
                      Logout
                    </Button>
                  </Tooltip>
                  <Button
                    component={NavLink}
                    className="hover:bg-red-300 rounded-2xl"
                    to={`/dashboard/sub-premium-plan`}
                    sx={[
                      {
                        cursor: "pointer",
                        // my: 2,
                        fontWeight: "bold",
                        color: "white",
                        display: "flex",
                        px: 3,
                        my: 2,
                        background: red[800],
                      },
                      (theme) => ({
                        [theme.breakpoints.down("429")]: {
                          display: "none",
                        },
                      }),
                    ]}
                  >
                    {/* <IconButton>
              </IconButton> */}
                    <UpgradeOutlinedIcon />
                    Upgrade
                  </Button>
                </Box>
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" open={open}>
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List
          sx={{
            py: 4,
          }}
        >
          <Link to={"/dashboard"}>
            <ListItem disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <Tooltip title="Home">
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <HomeIcon />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText primary={"Home"} sx={{ opacity: open ? 1 : 0 }} />
              </ListItemButton>
            </ListItem>
          </Link>

          {isSuccess && data?.getUserObject?.user_type === "bussiness" ? (
            <>
              <Link to={"/dashboard/post-job"}>
                <ListItem disablePadding sx={{ display: "block" }}>
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <Tooltip title="Post Job">
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                        }}
                      >
                        <PostAddIcon />
                      </ListItemIcon>
                    </Tooltip>
                    <ListItemText
                      primary={"Post Job"}
                      sx={{ opacity: open ? 1 : 0 }}
                    />
                  </ListItemButton>
                </ListItem>
              </Link>
              <Link to={"/dashboard/my-job"}>
                <ListItem disablePadding sx={{ display: "block" }}>
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <Tooltip title="Post Job">
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                        }}
                      >
                        <WorkHistoryIcon />
                      </ListItemIcon>
                    </Tooltip>
                    <ListItemText
                      primary={"My Job"}
                      sx={{ opacity: open ? 1 : 0 }}
                    />
                  </ListItemButton>
                </ListItem>
              </Link>
            </>
          ) : (
            <>
              <Link to={"/dashboard/find-job"}>
                <ListItem disablePadding sx={{ display: "block" }}>
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <Tooltip title="Find Job">
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                        }}
                      >
                        <FindInPageIcon />
                      </ListItemIcon>
                    </Tooltip>
                    <ListItemText
                      primary={"Find Job"}
                      sx={{ opacity: open ? 1 : 0 }}
                    />
                  </ListItemButton>
                </ListItem>
              </Link>
              <Link to={"/dashboard/my-pro-profile"}>
                <ListItem disablePadding sx={{ display: "block" }}>
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <Tooltip title="My Profile">
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                        }}
                      >
                        <Person3Icon />
                      </ListItemIcon>
                    </Tooltip>
                    <ListItemText
                      primary={"My Profile"}
                      sx={{ opacity: open ? 1 : 0 }}
                    />
                  </ListItemButton>
                </ListItem>
              </Link>
            </>
          )}
        </List>
        <Divider />
      </Drawer>
    </Box>
  );
}
